<template lang="pug">
.resume
    .resume__item(
        v-for='(item, index) in resume',
        :key='`${resumeId}-item-${index}`'
    )
        .resume__label {{ item.label }}
        .resume__value {{ item.value || '--' }}
</template>
<script>
export default {
    name: 'Resume',
    props: {
        resumeId: {
            type: String,
            required: true
        },
        resume: {
            type: [
                {
                    key: String,
                    label: String,
                    value: String
                }
            ],
            default: () => []
        }
    }
};
</script>

<style lang="scss">
.resume {
    display: flex;
    flex-direction: column;
    gap: 18px;
    &__item {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    &__label {
        font-weight: bold;
        color: var(--primary);
    }
    &__value {
        font-size: 16px;
        color: #3b3b3b;
    }
}
</style>
